import React from "react";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

class Confirm extends React.Component{
    render(){
        const {title,onConfirm}=this.props
        return  <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={onConfirm}
        onCancel={onConfirm}
        confirmBtnCssClass={
          this.props.classes.button + " " + this.props.classes.success
        }
      >
      </SweetAlert>
    }
}
export default withStyles(sweetAlertStyle)(Confirm);




// WEBPACK FOOTER //
// ./src/components/Alert/Success.jsx